import { render, staticRenderFns } from "./PaymentEstimator.vue?vue&type=template&id=629be4cb&scoped=true&"
import script from "./PaymentEstimator.vue?vue&type=script&lang=js&"
export * from "./PaymentEstimator.vue?vue&type=script&lang=js&"
import style0 from "./PaymentEstimator.vue?vue&type=style&index=0&id=629be4cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../PatientEnrollment/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629be4cb",
  null
  
)

export default component.exports